import { IconTemplate } from '@components/Icon/IconTemplate';
import { rem } from 'polished';
import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';

export const Contact = styled.div`
    padding: ${rem(20)} 0;

    @media (min-width: ${breakpoints.md}px) {
        display: flex;
        align-items: flex-start;
    }
`;

export const Company = styled.div`
    padding: 0 ${rem(20)} ${rem(20)} 0;

    @media (min-width: ${breakpoints.md}px) {
        min-width: 35%;
    }
`;

export const Transportation = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: ${rem(35)};
    padding: ${rem(10)} 0;

    @media (min-width: ${breakpoints.md}px) {
        flex-direction: row;
        justify-content: space-between;
    }

    @media (min-width: ${breakpoints.lg}px) {
        padding: ${rem(10)} 0;
    }
`;

export const TransportationOptions = styled.div`
    width: 100%;
    padding: ${rem(10)} 0;

    @media (min-width: ${breakpoints.md}px) {
        width: 65%;
    }

    @media (min-width: ${breakpoints.lg}px) {
        padding: ${rem(10)} 0;
    }
`;

export const TransportationOption = styled.div``;

export const TransportationHeader = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: ${rem(20)} 0;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
    cursor: pointer;
`;

export const TransportationHeaderTitle = styled.span`
    font-size: ${rem(18)};
`;

export const TransportationHeaderIcon = styled(IconTemplate)`
    svg {
        width: ${rem(20)};
        height: ${rem(20)};
    }

    &.isOpen {
        svg {
            transform: rotate(180deg);
        }
    }
`;

export const TransportationDescription = styled.div`
    padding-top: ${rem(10)} 0;
`;

export const CompanyLabel = styled.span<{ marginTop?: number; isBold?: boolean }>`
    display: block;
    padding-bottom: ${rem(5)};
    ${(prop) => (prop.marginTop ? `margin-top: ${rem(prop.marginTop)}` : '')};
    ${(prop) => (prop.isBold ? `font-weight: ${prop.theme.fontWeights.textBold}` : '')};
    ${(prop) => (prop.isBold ? `font-size: ${prop.theme.fontSizes.h6}` : '')};
`;

export const CompanyLink = styled.a<{ marginTop?: number; isBold?: boolean }>`
    display: block;
    padding-bottom: ${rem(8)};
    font-size: ${({ theme }) => theme.fontSizes.textBase};
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.primary};
    cursor: pointer;
    margin-top: ${rem(2)};
`;

export const Map = styled.div`
    width: 100%;

    iframe {
        border-radius: ${rem(16)};

        @media (min-width: ${breakpoints.sm}px) {
            min-height: ${rem(500)};
        }
    }
`;

export const ContactMap = styled.div``;
